import Vue from 'vue'
import VueGtag from 'vue-gtag'
import router from '../router'

Vue.use(VueGtag, {
  config: {
    id: 'UA-161531697-1'
  },
  appName: 'Moonly Landing',
  pageTrackerScreenviewEnabled: true
}, router)
